import { proxy } from 'valtio';

interface iStep {
  label: string;
  isCompleteted: boolean;
  hasError?: boolean;
  subSteps?: {
    label: string;
    isCompleted: boolean;
  }[];
}

const store = proxy({
  steps: [] as iStep[],
  currentStep: { step: 0, subStep: 0 },
  bankCheckData: { inst_num: '', bank_name: '', trans_number: [] } as any,
});

export default store;
